/** @jsx React.DOM */
var React = require('react/addons')

var TransactionLink = React.createClass({displayName: 'TransactionLink',
  render: function() {
    return React.DOM.span(null, 
      React.DOM.a({href: '#/wrt/transactions/' + this.props.hash, title: this.props.hash}, 
        this.props.hash.substr(0, 7)
      )
    )
  }
})

module.exports = TransactionLink



//////////////////
// WEBPACK FOOTER
// ./src/partials/wrt/transaction-link.jsx
// module id = 479
// module chunks = 0